import LabServiceModel from "@/models/LabServiceModel";
import LaboratoryModel from "@/models/lab/LaboratoryModel";
import CustomerModel from "@/models/crm/CustomerModel";
import CustomerContactModel from "@/models/crm/CustomerContactModel";
import CustomerLocationModel from "@/models/crm/CustomerLocationModel";
import SubmissionCollection from "../../collections/lab/SubmissionCollection";
import InvoiceModel from "../cashier/InvoiceModel";
import ProjectStatusLogCollection from "../../collections/lab/ProjectStatusLogCollection";

export default class ProjectModel extends LabServiceModel {

  options() {
    let options = super.options();
    options.methods = options.methods || super.methods() || {};
    options.methods.checkout = 'POST';
    return options;
  }

  routes() {
    let routes = super.routes() || {};
    routes.checkout = process.env.VUE_APP_LAB_REPOSITORY_URL + '/api/v1/' + this.modelName() + '/checkout';
    return routes;
  }

  modelName() {
    return 'project';
  }

  icon() {
    return 'shovel';
  }

  defaults() {
    return {
      id: null,
      pid: null,
      laboratory_id: null,
      laboratory: null,
      customer_id: null,
      customer: null,
      customer_location_id: null,
      customer_contact_id: null,
      invoice_id: null,
      invoice: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      project_status_logs: [],
      current_project_status_log: null,
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      pid: (val) => (this.nullStringMutator(val)),
      laboratory_id: (val) => (this.nullStringMutator(val)),
      customer_id: (val) => (this.nullStringMutator(val)),
      customer_location_id: (val) => (this.nullStringMutator(val)),
      customer_contact_id: (val) => (this.nullStringMutator(val)),
      invoice_id: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  checkout() {
    let method = this.getOption('methods.checkout');
    let route  = this.getRoute('checkout');
    let url    = this.getURL(route);
    let data   = {
      laboratory_id: this.get('laboratory_id'),
      customer_id: this.get('customer_id'),
      customer_contact_id: this.get('customer_contact_id'),
      customer_location_id: this.get('customer_location_id'),
      invoice_id: this.get('invoice_id'),
      submissions: this.get('submissions'),
    };
    return this.createRequest({method, url, data}).send();
  }

  getCustomer() {
    return this.getRelatedModel(CustomerModel, 'customer');
  }

  getLaboratory() {
    return this.getRelatedModel(LaboratoryModel, 'laboratory');
  }

  getCustomerContact() {
    return this.getRelatedModel(CustomerContactModel, 'customer_contact');
  }

  getCustomerLocation() {
    return this.getExternalRelatedModel(CustomerLocationModel, 'customer_location', 'customer_location_id');
  }

  getProjectStatusLogs() {
    return this.getRelatedCollection(( new ProjectStatusLogCollection()), 'project_status_logs');
  }

  getSubmissions() {
    return this.getRelatedCollection(( new SubmissionCollection()), 'submissions');
  }

  /*
  getInvoice() {
    let invoice = new InvoiceModel({id: this.invoice_id});
    invoice.fetch();
    return invoice;
  }*/

  publicNumber() {
    if(!this.get('pid')) {
      return null;
    }
    return this.get('pid')
  }

}
